export const IGNORE_LIST = ['LOCALSTORAGE'];
export const shouldIgnore = (type: string | undefined) => IGNORE_LIST.some((item) => type?.includes(item));
